export default __webpack_public_path__ + "static/media/dummy2.ed878641.png";